export const action = state => state.action
export const tab_name = state => state.tab_name
export const user_name = state => state.user_name
export const cache_data = state => state.cache_data
export const talgIndex = state => state.talgIndex



// WEBPACK FOOTER //
// ./src/store/getters.js